<img #hiddenImageLightMode [src]="SrcLightMode" style="display: none" />
<img #hiddenImageDarkMode [src]="SrcDarkMode" style="display: none" />

<div
  class="course-logo-wrapper"
  [ngClass]="{
    '--contained': isContained == true,
    '--elevated': isElevated == true,
  }"
  [style.--course-logo-intrinsic-width]="
    logoSrc === SrcLightMode ? intrinsicWidthLightMode : intrinsicWidthDarkMode
  "
  [style.--course-logo-intrinsic-height]="
    logoSrc === SrcLightMode
      ? intrinsicHeightLightMode
      : intrinsicHeightDarkMode
  "
>
  <img [src]="logoSrc === SrcLightMode ? SrcLightMode : SrcDarkMode" />
</div>
